import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import "../../styles/Footer.css";
import logo from "../../assets/images/logo1.png";

const Footer = () => {
  const { language } = useLanguage();

  const menuItems =
    language === "en"
      ? [
          { title: "Company introduction", path: "/en/about/greeting" },
          { title: "product descriptions", path: "/en/products" },
          { title: "Construction case", path: "/en/portfolio" },
          { title: "Q&A", path: "/en/board" },
          { title: "Release", path: "/en/releases" },
        ]
      : [
          { title: "회사소개", path: "/about/greeting" },
          { title: "제품소개", path: "/products" },
          { title: "시공사례", path: "/portfolio" },
          { title: "Q&A", path: "/board" },
          { title: "릴리즈", path: "/releases" },
        ];

  const policyLinks =
    language === "en"
      ? [
          { title: "Privacy Policy", path: "/en/privacy" },
          { title: "Terms of Use", path: "/en/terms" },
          { title: "Reject Unauthorized Email Collection", path: "/en/email-policy" },
        ]
      : [
          { title: "개인정보 취급방침", path: "/privacy" },
          { title: "이용약관", path: "/terms" },
          { title: "이메일무단수집거부", path: "/email-policy" },
        ];

  const contactInfo =
    language === "en"
      ? {
          slogan: "Sustainable greenhouses are the foundation of future agriculture",
          inquiryPhone: "Inquiry Number",
          tel: "Tel : +82) 063-225-8274",
          address: "Room 108, Room 110 of B-dong B, Banyong-ro, Deokjin-gu, Jeonju-si, Jeollabuk-do, Republic of Korea",
          copyright: "Copyright(c) ECOTECH GLOBAL 2025 ALL Rights Reserved.",
        }
      : {
          slogan: "지속가능한 온실은 미래 농업의 기반입니다",
          inquiryPhone: "문의전화",
          tel: "Tel : +82) 063-225-8274",
          address: "560-838 전북 전주시 덕진구 반룡로 109 JBTP테크노빌 B동 108호, 110호",
          copyright: "Copyright(c) ECOTECH GLOBAL 2025 ALL Rights Reserved.",
        };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="logo-section">
            <img src={logo} alt="ECOTECH GLOBAL" className="ecofarm-logo" />
            <p className="slogan">{contactInfo.slogan}</p>
          </div>
          <div className="menu-section menu-section-en">
            <ul>
              {menuItems.map((item, index) => (
                <li key={index}>
                  <Link to={item.path}>{item.title}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer-middle">
          <div className="contact-info">
            <span>
              {contactInfo.inquiryPhone}
              &nbsp;+82) 010-9448-0345
            </span>
            <span>{contactInfo.tel}</span>
            <span>{contactInfo.address}</span>
          </div>
        </div>

        <hr className="divider" />

        <div className="footer-bottom">
          <div className="policy-links">
            {policyLinks.map((link, index) => (
              <Link key={index} to={link.path}>
                {link.title}
              </Link>
            ))}
          </div>
          <div className="copyright">
            <p>{contactInfo.copyright}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
